import { useEffect, useRef } from 'react';

export const partytownConfig = [
  'analytics.trackSubmit',
  'analytics.trackClick',
  'analytics.trackLink',
  'analytics.trackForm',
  'analytics.pageview',
  'analytics.identify',
  'analytics.reset',
  'analytics.group',
  'analytics.track',
  'analytics.ready',
  'analytics.alias',
  'analytics.debug',
  'analytics.page',
  'analytics.once',
  'analytics.off',
  'analytics.on',
  'analytics.addSourceMiddleware',
  'analytics.addIntegrationMiddleware',
  'analytics.setAnonymousId',
  'analytics.addDestinationMiddleware',
  'FS',
];

interface UseSegmentProps {
  readonly enabled: boolean;
  readonly isPartytownEnabled?: boolean;
}

export const useSegment = ({ enabled, isPartytownEnabled }: UseSegmentProps): void => {
  const segmentLoaded = useRef(false);

  useEffect(() => {
    if (segmentLoaded.current || !enabled) return;

    segmentLoaded.current = true;
    const script = document.createElement('script');
    script.type = isPartytownEnabled ? 'text/partytown' : 'text/javascript';
    script.id = 'segment';
    script.text = `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${process.env.SEGMENT_ID}";analytics.SNIPPET_VERSION="4.15.2";
    analytics.load("${process.env.SEGMENT_ID}");
    analytics.page();
    }}();`;
    document.head.append(script);
    window.dispatchEvent(new CustomEvent('ptupdate'));
  }, [enabled, isPartytownEnabled]);
};
